module.exports = __webpack_public_path__ + "img/2021_IMG_20210208_142902.06ab0cbd.jpg";